import { useEffect, useState } from "react";
import { isEqual } from "lodash";

function useAlertHitPoints({ alertsToPlot, fromDate, toDate, selectedPlant, isRegionNa, getAlertHits, prevAlertsToPlot }) {

    const [hitPointsDict, setHitPointsDict] = useState({})

    useEffect(() => {
        const checkIfOldAlert = (a) => {
            const isNotInList = !prevAlertsToPlot.current.some(alert => alert.id === a.id);
            if (isNotInList) {
                return false;
            } else {
                const alertToCheck = prevAlertsToPlot.current.find(alert => alert.id === a.id);
                return isEqual(a, alertToCheck);
            }
        }

        const getNewAlertsToPlot = () => {
            const newAlertsToPlot = alertsToPlot.filter(a => !checkIfOldAlert(a));
            return newAlertsToPlot;
        }

        const findHits = async () => {
            const alertsToEval = prevAlertsToPlot.current !== null ? getNewAlertsToPlot() : alertsToPlot;
            if (alertsToEval.length > 0) {
                const hitPoints = await getAlertHits(alertsToEval, selectedPlant, fromDate, toDate)
                setHitPointsDict(prevHitPointsDict => ({ ...prevHitPointsDict, ...hitPoints }));
                prevAlertsToPlot.current = alertsToPlot;
            }
        }
        findHits();

    }, [alertsToPlot, fromDate, toDate, selectedPlant, isRegionNa, getAlertHits, prevAlertsToPlot])

    return { hitPointsDict, setHitPointsDict };

} export default useAlertHitPoints;